<template>
  <!--
  <div class="app flex-row align-items-center"
      :style="{ backgroundImage: 'url(img/background.jpg)' }">
  -->      
  <div class="app app-body flex-row align-items-center">
    <div id="spinner" class="justify-content-center align-items-center"
        :style="{ height: spinnerHeight + 'px', 
          width: spinnerWidth + 'px' }" 
        v-if="isProcesando">
      <b-spinner id="spinner-spin" label="Loading...">
      </b-spinner>
    </div>

    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <b-card-group>
            <b-card no-body class="p-4 login-card">
              <b-card-body>
                <b-form>
                  <h1>Iniciar Sesión</h1>
                  <p class="text-muted">Seleccione la empresa</p>

                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-organization"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-select 
                      class="form-control custom-select"
                      v-model="empresaNombre" 
                      :options="empresasList"
                      :state="empresaValida"
                      @blur.native="empresaActualizada">
                      <template slot="first">
                        <option :value="null" :disabled="true">Seleccione una Empresa</option>
                      </template>
                    </b-form-select>
                    <b-form-invalid-feedback id="feedback">
                      Seleccione la empresa
                    </b-form-invalid-feedback>
                  </b-input-group>
                  <b-row>
                    <b-col cols="12">
                      <b-button variant="primary" 
                        class="px-4"
                        :disabled="!loginEnabled"
                        @click.prevent="seleccionarEmpresa">Seleccionar</b-button>
                      <b-button variant="primary" 
                        class="px-4"
                        @click.prevent="goBack">Volver</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>

          <b-alert
            class="alert"
            :show="dismissCountDown"
            dismissible
            fade
            :variant="alertVariant"
            @dismissed="dismissCountDown= 0"
            @dismiss-count-down="countDownChanged">
            <p>{{ alertMsj }}</p>
          </b-alert>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Empresa from '../shared/abmSelect.vue';
import { msjAlert } from '../../mixins/msjAlert';

export default {
  name: 'Login',
  components: {
    appEmpresa: Empresa
  },
  mixins: [ 
    msjAlert
  ],
  props: {
    username: {
      type: String,
      default: ''
    },
    password: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      empresa: null,
      empresaNombre: null,
      empresas: null,
      empresasList: [],
      empresaValida: null,
    }
  },
  computed: {
    loginEnabled () {
      let enabled = false;
      if (this.username.trim() != '' && this.password.trim() != '') {
        enabled = true;
      }
      return enabled;
    },
    isProcesando: {
      get: function () {
        return this.$store.getters['spinnerProcesando/procesando'];
      },
      set: function (newValue) {
      }
    },
    spinnerHeight: {
      get: function () {
        return this.$store.getters['spinnerProcesando/height'];
      },
      set: function (newValue) {
      }
    },
    spinnerWidth: {
      get: function () {
        return this.$store.getters['spinnerProcesando/width'];
      },
      set: function (newValue) {
      }
    },
  },
  created() {
    this.getEmpresas();
  },
  methods: {
    getEmpresas() {
      this.$store.dispatch('empresas/getList')
        .then(() => {
          this.empresas = this.$store.getters['empresas/list']
          this.empresasList = this.$store.getters['empresas/selectList']
        })
        .catch(error => this.showAlertError(error))
    },
    seleccionarEmpresa (){
      if (this.empresa) {
        let credenciales = {
          username: this.username,
          password: this.password,
          empresaId: this.empresa.id,
        }

        this.showSpinner();
        this.$store.dispatch('user/login', credenciales)
          .then(res => {
            this.$router.push({ name: 'Home' });
          })
          .catch(error => this.showAlertError(error))
          .finally(() => this.hideSpinner());
      } else {
        this.empresaValida = false;
      }
    },
    empresaActualizada() {
      this.empresa = null;
      if (this.empresaNombre) {
        this.empresa = this.empresas.find( empresa => empresa.nombreComercial.trim() == this.empresaNombre.trim());
      }
      this.empresaValida = null;
    },    
    goBack() {
      this.$router.push({ name: 'Login' });
    },    
  }
}
</script>

<style>
</style>